<template>
  <div class="drawer-search-list">
    <!-- <ul
      v-if="companies.length !== 0&&fold"
    >
      <li :class="[company._id === item._id ? 'high-light-text' : '']"
          class="serchlist-item drawer_list_item"
          @click="chooseCompany(item._id)"
      >
        <div style="overflow:hidden">
          <div>
            <span class="companyname">{{ item.公司名称 }}</span>
            <span>（简称：{{ item.简称 }}）                                                                       </span>
          </div>
          <div class="search-tag-box">
            <span v-if="item.公司性质" class="search-tag success">{{item.公司性质}}</span>
            <span v-if="item.平台等级" class="search-tag primary">{{translateLevel[item.平台等级]}}（{{item.平台等级}}）</span>
            <span v-if="item.客户分类" class="search-tag warning">客户评分：{{item.客户分类}}</span>
          </div>
        </div>
      </li>
    </ul> -->
    <ul
      v-if="companies.length !== 0"
      :class="[fold ? 'company-list-fold' : '', 'company-list']"
    >
      <li
        v-for="item in showCompanies"
        :key="item._id"
        :class="[company._id !== item._id?'active':'','serchlist-item drawer_list_item']"
        @click="chooseCompany(item._id)"
      >
        <div style="overflow:hidden">
          <div :class="[company._id !== item._id ? 'high-light-text' : '']">
            <span class="companyname">{{ item.公司名称 }}</span>
            <span style="margin-bottom:4px;">（简称：{{ item.简称 }}）                                                                       </span>
          </div>
          <div>
            <p>客户经理：<span>{{item.客户开发 || '暂无'}}</span></p>
          </div>
          <div class="search-tag-box">
            <!-- <span v-if="item.公司性质" class="search-tag success">{{item.公司性质}}</span>
            <span v-if="item.平台等级" class="search-tag primary">{{translateLevel[item.平台等级]}}（{{item.平台等级}}）</span>
            <span v-if="item.客户分类" class="search-tag warning">客户评分：{{item.客户分类}}</span> -->
            <span v-if="item.行业" class="">{{item.行业}}</span>
            <span v-if="item.平台等级" class="">{{item.平台等级}}-{{translateLevel[item.平台等级]}}</span>
            <span v-if="item.公司性质" class="">{{item.公司性质}}</span>
            <span v-if="item.办公地" class="">{{item.办公地}}</span>
            <span v-if="item.公司阶段" class="">{{item.公司阶段}}</span>
          </div>
        </div>
      </li>
    </ul>
    <h4 v-else>没有搜索到公司</h4>
    <!-- <span v-if="showCompanies.length === 1&&showCompanies[0].网址" class="high-light-text" style="cursor:pointer" @click="openWebsite(showCompanies[0].网址)">查看官网</span> -->
    <div v-if="companies.length > 1" class="fold-btn" @click="modifyFold">
      <i v-if="fold" class="el-icon-arrow-down"></i>
      <i v-else class="el-icon-arrow-up"></i>
      <span>{{fold?'展开':'收起'}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    companies: { type: Array, default: () => [] },
    company: { type: Object, default: () => ({}) },
    fold: { type: Boolean, default: false },
  },
  data() {
    return {
      showCompanies: [],
      translateLevel: {
        A: '大平台',
        B: '中平台',
        C: '小平台',
      },
    }
  },
  watch: {
    fold(newValue, oldValue) {
      this.setShowCompanies()
    },
    companies(newValue, oldValue) {
      this.setShowCompanies()
    },
  },
  mounted() {
    this.setShowCompanies()
  },
  methods: {
    setShowCompanies() {
      if (this.fold) {
        const id = this.company._id
        this.showCompanies = id ? this.companies.filter(val => val._id === id) : this.companies
      } else {
        const index = this.companies.findIndex(
          val => val.简称 === this.companyName || val.公司名称 === this.companyName,
        )
        if (index !== -1) {
          const temp = this.companies[0]
          this.companies[0] = this.companies[index]
          this.companies[index] = temp
        }
        this.showCompanies = this.companies
      }
    },
    modifyFold() {
      this.$emit('modifyFold')
    },
    chooseCompany(id) {
      this.$emit('chooseCompany', { id })
    },
    openWebsite(str){
      const val = str ? str.replace(/[,，;；]/g, ';') : ''
      const arr = val
        .split(';')
        .filter(v => v)
        .map(v => (v.includes('http') ? v : `http://${v}`))
      if(arr[0])window.open(arr[0])
      else this.$message.error('网址错误')
    },
  },
}
</script>
<style scoped>
.drawer-search-list {
  padding-bottom: 8px;
}
.company-list {
  max-height: 190px;
  overflow: auto;
  padding: 0;
  list-style: none;
}
.company-list-fold {
}

.serchlist-item {
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
  padding: 4px 10px;
  color: #171717;
  border-radius: 8px;
}
/* .serchlist-item.active{
  background-color: #2478b5;
} */
/*   */
.serchlist-item:last-child {
  border: none;
}
.serchlist-item:hover{
  background-color: #8fbbd033;
  border-radius: 4px;
}
.high-light-text {
  color:#5aa2ea;
}
.companyname {
  font-size: 12px;
  line-height: 22px;
}
.search-tag-box {
  padding-top: 4px;
  padding-left:4px;
  color: #bfbfbf;
  /* padding: 5px 0; */
}
.search-tag {
  margin-right: 21px;
  margin-bottom: 5px;
  padding: 4px 8px;
  display: inline-block;
  border-radius: 15px;
  border: 1px solid;
}
.search-tag.success {
  background-color: #e2f6f4;
  color: #69d0c5;
  border-color: #69d0c5;
}
.search-tag.primary {
  background-color: #f3dcc48c;
  color: #e8a361;
  border-color: #e8a361;
}
.search-tag.warning {
  background-color: #fff1b8;
  color: #faad14;
  border-color: #faad14;
}
.fold-btn {
  width: 100%;
  line-height: 20px;
  margin: 5px 0;
  color: #19b1e0;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
}
.search-tag-box span::after{
  content: '|';
  margin: 0 4px;
  display: inline-block;
}
.search-tag-box span:last-child::after{
  content: '|';
  display: none;
}
</style>
